import { createContext, useContext } from 'react'

interface toast {
  open: string
  type: string
  message: string
}

export type GlobalContent = {
  showLoading: string
  showToast: toast
  setShowLoading: (open: string) => void
  setShowToast: (toastContent: toast) => void
}

export const MyGlobalContext = createContext<GlobalContent>({
  showLoading: 'false',
  showToast: { open: 'false', type: '', message: '' },
  setShowLoading: () => {},
  setShowToast: () => {},
})

export const useGlobalContent = () => useContext(MyGlobalContext)
